module.exports = __webpack_public_path__ + "img/curriculum.412b7fe0.png";